import styled from 'styled-components';

export const StyledUserPanelTournamentScript = styled.div`
    width: 100%;
    padding-top: 44px;
`;
